<template>
  <div class="holiday-rest">
    <h3>{{ $t('110') }}</h3>
    <el-form :inline="true" :model="dataForm">
      <div>
        <el-form-item :label="$t('27')">
          <el-popover v-model="popover" ref="orgPopover" placement="bottom-start" trigger="click">
            <dep-tree v-if="popover" @node-click="handleNodeClick"></dep-tree>
          </el-popover>
          <el-input
            v-model="dataForm.department_name"
            v-popover:orgPopover
            :placeholder="$t('19')"
            clearable
            @clear="departmentClear"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('142')">
          <staff-search comment="comment" @change="staffChange"></staff-search>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="getTableList">
            {{ $t('80') }}
          </el-button>
        </el-form-item>
      </div>
      <div>
        <el-button type="primary" plain @click="modifyHoliday" v-if="$p('menu.work.rule.edit')">
          {{ $t('holiday_rest_6') }}
        </el-button>
      </div>
    </el-form>
    <el-table
      :data="page.list"
      :loading-text="$t('989')"
      :highlight-current-row="true"
      stripe
      style="width: 100%"
      ref="table"
      @sort-change="handlerSort"
    >
      <!-- 工号 -->
      <el-table-column
        prop="staff_code"
        sortable="custom"
        :label="$t('25')"
        fixed="left"
        width="150"
        align="center"
      ></el-table-column>
      <!--姓名-->
      <el-table-column prop="staff_name" sortable="custom" :label="$t('22')" align="center" width="200" fixed="left">
      </el-table-column>
      <!--部门-->
      <el-table-column prop="department_name" :label="$t('27')" align="center" width="200"> </el-table-column>
      <!--入职时间-->
      <el-table-column prop="hire_date" sortable="custom" :label="$t('28')" align="center" width="200">
      </el-table-column>
      <el-table-column
        v-for="(item, index) in holidayArr"
        :key="index"
        :prop="item.type_id"
        :label="item.type_name"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <template v-if="item.is_setting === '1'">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('1535')"
              placement="top-start"
              v-if="scope.row[item.type_id] == -1"
            >
              <span>{{ $t('1589') }}</span>
            </el-tooltip>
            <el-button v-else type="text" @click="holidayHandle(item, scope.row)">
              {{ scope.row[item.type_id] }}
            </el-button>
          </template>
          <span v-else>
            {{ $t('917') }}
          </span>
        </template>
      </el-table-column>
      <el-table-column></el-table-column>
    </el-table>
    <el-pagination
      layout="total, sizes, prev, pager, next"
      :page-sizes="pageSizes"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :total="page.total"
      :current-page="page.currPage"
      :page-size="page.limit"
    >
    </el-pagination>
    <holiday-dialog v-if="isHolidayDialog" ref="holidayDialog" @getTableList="getTableList"></holiday-dialog>
    <upload-dialog ref="uploadDialog"></upload-dialog>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
import depTree from '@/components/dep-tree'
import staffSearch from '_c/staff-search'
import holidayDialog from './holiday-dialog'
import { restListFn } from 'api/approval/config'
import uploadDialog from './uploadDialog'

export default {
  components: {
    depTree,
    staffSearch,
    holidayDialog,
    uploadDialog
  },
  data() {
    return {
      popover: false,
      dataForm: {},
      pageSizes: [100, 50, 20],
      page: {
        list: [],
        currPage: 1,
        limit: 100,
        total: 0
      },
      sort: '',
      dir: '',
      holidayArr: [],
      isHolidayDialog: false
    }
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    // 排序
    handlerSort({ prop, order }) {
      this.sort = prop
      this.dir = order
      this.getTableList()
    },
    handleNodeClick(val) {
      this.dataForm = Object.assign(this.dataForm, val)
      this.popover = false
    },
    staffChange(val) {
      this.dataForm = Object.assign(this.dataForm, val)
    },
    modifyHoliday() {
      this.$refs.uploadDialog.init()
    },
    async getTableList() {
      const res = await restListFn({
        page: this.page.currPage,
        size: this.page.limit,
        sort: this.sort, // 排序相关
        dir: this.dir,
        ...this.dataForm
      })
      this.$emit('clear-loading')
      if (res && res.code === 1 && res.data) {
        this.page.total = res.data.count
        this.holidayArr = res.data.type_list
        this.page.list = res.data.leave_list
        this.$nextTick(() => this.$refs.table.doLayout && this.$refs.table.doLayout())
      } else {
        this.page.total = 0
        this.holidayArr = []
        this.page.list = []
      }
    },
    // 每页条数
    sizeChangeHandle(val) {
      this.page.limit = val
      this.getTableList()
    },
    // 切换 页
    currentChangeHandle(val) {
      this.page.currPage = val
      this.getTableList()
    },
    holidayHandle(item, row) {
      if (this.$p('menu.work.rule.edit')) {
        this.isHolidayDialog = true
        this.$nextTick(() => this.$refs.holidayDialog.init(item, row))
      }
    },
    departmentClear() {
      this.dataForm.department_id = null
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  display: flex;
  justify-content: space-between;
}
</style>
